import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faLanguage } from "@fortawesome/free-solid-svg-icons";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import Breadcrumbs from "../../Navigation/Components/Breadcrumbs";
import { useTranslation } from "react-i18next";
import "./NewTrainingForm.css";

function NewTrainingForm() {
  const [name, setName] = useState("");
  const [expiration, setExpiration] = useState(null);
  const [nameEnglish, setNameEnglish] = useState("");
  const [english, setEnglish] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [groups, setGroups] = useState([]);
  const [group, setGroup] = useState();
  const [expires, setExpires] = useState(false);

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/trainingGroups/organization/${state.organization}`,
        data: { language: state.language },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setGroups(response.data.trainingGroups);
      if (state.language === "en") {
        setEnglish(true);
      } else {
        setEnglish(false);
      }
      setIsLoading(false);
    }
    fetch();
  }, [state.language, state.organization, state.token]);

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleNameEnglishChange = (e) => {
    setNameEnglish(e.target.value);
  };

  const activateEnglish = () => {
    setEnglish(true);
  };

  const handleExpirationChange = (e) => {
    setExpiration(e.target.value);
  };

  const handleGroupChange = (e) => {
    setGroup(e.target.value);
  };

  const handleExpiresChange = (e) => {
    setExpires(e.target.checked);
  };

  const handleSubmit = async () => {
    try {
      await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/trainings`,
        data: {
          name: name,
          name_english: nameEnglish,
          expiration: expiration,
          expires: expires,
          organization: state.organization,
          group: group,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/trainings");
    } catch (error) {
      console.log(error.response.data);
    }
  };

  let breadcrumbs = [
    {
      title: state.language === "es" ? "Capacitaciones" : "Trainings",
      path: "/trainings",
    },
  ];

  if (isLoading) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row>
          <Breadcrumbs data={breadcrumbs} />
        </Row>
        <Row>
          <Col lg={11} className="new-training-header">
            <h2>
              {t("Capacitaciones.Capacitacion.NewForm.NuevaCapacitacion")}
            </h2>
          </Col>
          <Col lg={1} className="new-scale-header mb-2">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                <FontAwesomeIcon icon={faList} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={activateEnglish}>
                  <FontAwesomeIcon icon={faLanguage} /> English
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
        <Row>
          <Col className="new-training-form">
            <Form>
              <FloatingLabel
                controlId="floatingInput"
                label="Nombre de la capacitacion"
                className="mb-3"
              >
                <Form.Control
                  type="text"
                  placeholder="nombre de la capacitacion"
                  onChange={handleNameChange}
                />
              </FloatingLabel>
              {english ? (
                <FloatingLabel label="Training title" className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Training title"
                    onChange={handleNameEnglishChange}
                  />
                </FloatingLabel>
              ) : (
                <></>
              )}
              <Form.Group className="mb-3">
                <Form.Select
                  aria-label="Seleccionar grupo"
                  onChange={handleGroupChange}
                >
                  <option>
                    {t("Capacitaciones.Capacitacion.NewForm.SeleccionarGrupo")}
                  </option>
                  {groups.map((item) => (
                    <option key={item._id} value={item._id}>
                      {state.language === "es" ? item.name : item.name_english}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Check
                  label={english ? "Expires?" : "Expira?"}
                  type="switch"
                  onChange={handleExpiresChange}
                />
              </Form.Group>

              {expires ? (
                <FloatingLabel
                  label={english ? "Expiration in months" : "Vigencia en meses"}
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="# de meses"
                    onChange={handleExpirationChange}
                  />
                </FloatingLabel>
              ) : (
                <></>
              )}

              <Button className="primary" onClick={handleSubmit}>
                {t("Capacitaciones.Capacitacion.NewForm.Guardar")}
              </Button>
              <Link to="/trainings">
                <Button className="danger">
                  {t("Capacitaciones.Capacitacion.NewForm.Cancelar")}
                </Button>
              </Link>
            </Form>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default NewTrainingForm;
